<app-ui-dialog
  ariaLabel="Confirm your attendance at the event you signed up for"
  title="Confirm your attendance"
  [(open)]="open">
  @if (pendingEvent(); as event) {
    <div class="space-y-3 text-sm" data-testid="pending-event-dialog">
      @switch (status()) {
        @case ('reserved') {
          <p class="font-semibold">
            Your place at {{ event.title }} is reserved. Please still confirm your email to gain full access.
          </p>
        }
        @case ('unavailable') {
          <p>Sorry, {{ event.title }} is no longer open: it has already taken place or was cancelled.</p>
        }
        @case ('refused') {
          <p class="text-red-600">
            We couldn't confirm your attendance. Please get in touch with us if you think this is a mistake.
          </p>
        }
        @default {
          <p>
            You signed up for
            <span class="font-semibold">{{ event.title }}</span>
            on
            <app-ui-date-display format="MMM dd, y, HH:mm" [value]="event.date" />. Would you like to confirm your
            attendance?
          </p>
          @if (status() === 'failed') {
            <p class="text-red-600">We couldn't confirm your attendance just now. Please try again.</p>
          }
        }
      }
    </div>
  }

  <div dialogFooter class="flex justify-end gap-2">
    @if (canConfirm()) {
      <app-ui-button intent="ghost" size="sm" [disabled]="status() === 'confirming'" (click)="dismiss()">
        No thanks
      </app-ui-button>
      <app-ui-button intent="primary" size="sm" [loading]="status() === 'confirming'" (click)="confirmAttendance()">
        Confirm attendance
      </app-ui-button>
    }
  </div>
</app-ui-dialog>
